/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_AssetsInputs */

const id_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ms_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset`)
};

const da_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const de_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const en_us2_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_es2_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_mx2_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const fil_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Asset`)
};

const fr_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const it_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const hu_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-ek`)
};

const nl_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const no_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiendeler`)
};

const pl_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const pt_br2_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const pt_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ro_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-uri`)
};

const fi_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssit`)
};

const sv_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgångar`)
};

const vi_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const tr_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assetler`)
};

const cs_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assety`)
};

const bg_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активи`)
};

const ru_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассетов`)
};

const uk_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ar_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأصول`)
};

const hi_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट्स`)
};

const th_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซท`)
};

const ja_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセット`)
};

const zh_cn2_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const zh_hant1_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ko_components_stats_assets = /** @type {(inputs: Components_Stats_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

/**
* | output |
* | --- |
* | "Assets" |
*
* @param {Components_Stats_AssetsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_assets = /** @type {((inputs?: Components_Stats_AssetsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_AssetsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_assets(inputs)
	if (locale === "ms") return ms_components_stats_assets(inputs)
	if (locale === "da") return da_components_stats_assets(inputs)
	if (locale === "de") return de_components_stats_assets(inputs)
	if (locale === "en-US") return en_us2_components_stats_assets(inputs)
	if (locale === "es-ES") return es_es2_components_stats_assets(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_assets(inputs)
	if (locale === "fil") return fil_components_stats_assets(inputs)
	if (locale === "fr") return fr_components_stats_assets(inputs)
	if (locale === "it") return it_components_stats_assets(inputs)
	if (locale === "hu") return hu_components_stats_assets(inputs)
	if (locale === "nl") return nl_components_stats_assets(inputs)
	if (locale === "no") return no_components_stats_assets(inputs)
	if (locale === "pl") return pl_components_stats_assets(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_assets(inputs)
	if (locale === "pt") return pt_components_stats_assets(inputs)
	if (locale === "ro") return ro_components_stats_assets(inputs)
	if (locale === "fi") return fi_components_stats_assets(inputs)
	if (locale === "sv") return sv_components_stats_assets(inputs)
	if (locale === "vi") return vi_components_stats_assets(inputs)
	if (locale === "tr") return tr_components_stats_assets(inputs)
	if (locale === "cs") return cs_components_stats_assets(inputs)
	if (locale === "bg") return bg_components_stats_assets(inputs)
	if (locale === "ru") return ru_components_stats_assets(inputs)
	if (locale === "uk") return uk_components_stats_assets(inputs)
	if (locale === "ar") return ar_components_stats_assets(inputs)
	if (locale === "hi") return hi_components_stats_assets(inputs)
	if (locale === "th") return th_components_stats_assets(inputs)
	if (locale === "ja") return ja_components_stats_assets(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_assets(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_assets(inputs)
	return ko_components_stats_assets(inputs)
});
export { components_stats_assets as "components.stats.assets" }